import { render } from "./WikiChange.vue?vue&type=template&id=4e779812&scoped=true"
import script from "./WikiChange.vue?vue&type=script&lang=js"
export * from "./WikiChange.vue?vue&type=script&lang=js"

import "./WikiChange.vue?vue&type=style&index=0&id=4e779812&scoped=true&lang=css"
import "./WikiChange.vue?vue&type=style&index=1&id=4e779812&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e779812"]])

export default __exports__